module.exports = __webpack_public_path__ + "static/media/bookingSettings.fe410d85.jpg";